module.exports = __webpack_public_path__ + "img/project-12_old.d732c8fd.jpg";